import { render } from "./productAdditionalInformation.vue?vue&type=template&id=d3e78580"
import script from "./productAdditionalInformation.vue?vue&type=script&lang=js"
export * from "./productAdditionalInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__